import {t} from 'i18next';
import React, {useEffect, useState} from 'react';
import Chart from 'react-apexcharts';
import ApexCharts from 'react-apexcharts';

const PieChart1 = ({clientes}) => {
    // const [state, setState] = useState({
    //     series: [10, 26.8, 20.4, 10, 26.8],
    // });
    const [state, setState] = useState({
        series: clientes.slice(0, 5).map(c => c.valor),
    });
    const options = {
        colors: ['#1C64F2', '#16BDCA', '#9061F9', '#8bacfc', '#0484CA'],
        chart: {
            height: 420,
            width: '100%',
            type: 'pie',
        },
        stroke: {
            colors: ['white'],
            lineCap: '',
        },
        plotOptions: {
            pie: {
                labels: {
                    show: true,
                },
                size: '100%',
                dataLabels: {
                    offset: -25,
                },
            },
        },
        labels: clientes.slice(0, 5).map(c => c.nome), //['Direct', 'Organic search', 'Referrals'],
        dataLabels: {
            enabled: true,
            style: {
                fontFamily: 'Inter, sans-serif',
            },
        },
        legend: {
            position: 'bottom',
            fontFamily: 'Inter, sans-serif',
        },
        yaxis: {
            labels: {
                formatter: function (value) {
                    return value + '%';
                },
            },
        },
        xaxis: {
            labels: {
                formatter: function (value) {
                    return value + '%';
                },
            },
            axisTicks: {
                show: false,
            },
            axisBorder: {
                show: false,
            },
        },
    };

    useEffect(() => {
        if (document.getElementById('pie-chart') && typeof ApexCharts !== 'undefined') {
            const chart = new ApexCharts(document.getElementById('pie-chart'), options);
            chart.render();
        }
    }, []);

    return (
        <div className="max-w-sm w-full h-full bg-white rounded-[8px] shadow dark:bg-gray-800 p-4 md:p-6">
            <div className="flex justify-between items-start w-full">
                <div className="flex-col items-center">
                    <div className="flex items-center mb-1">
                        <h5 className="text-xl font-bold leading-none text-gray-900 dark:text-white me-1">{t('topCliente1Ano')}</h5>
                    </div>
                </div>
            </div>

            <div className="py-6" id="pie-chart">
                <ApexCharts options={options} series={state.series} type="pie" height={400} />
            </div>

            <div className="grid grid-cols-1 items-center border-gray-200 border-t dark:border-gray-700 justify-between"></div>
        </div>
    );
};

export default PieChart1;
